// AUTOMATICALLY GENERATED FILE: $ yarn create:/health-insurers-list
import type { ImageType } from '#base/core/types/ImageType';

const insurers: {
	name: string;
	logo: ImageType;
	blendMultiply?: boolean;
}[] = [
	{
		name: 'aevitae',
		logo: {
			alt: 'Zorgverzekeraar aevitae',
			src: '/img/health-insurers/aevitae.png',
			width: 80,
			height: 31,
		},
	},
	{
		name: 'anderzorg',
		logo: {
			alt: 'Zorgverzekeraar anderzorg',
			src: '/img/health-insurers/anderzorg.png',
			width: 80,
			height: 18,
		},
	},
	{
		name: 'aon',
		logo: {
			alt: 'Zorgverzekeraar aon',
			src: '/img/health-insurers/aon.png',
			width: 80,
			height: 30,
		},
	},
	{
		name: 'asr',
		logo: {
			alt: 'Zorgverzekeraar asr',
			src: '/img/health-insurers/asr.jpg',
			width: 80,
			height: 80,
		},
	},
	{
		name: 'azvz',
		logo: {
			alt: 'Zorgverzekeraar azvz',
			src: '/img/health-insurers/azvz.png',
			width: 80,
			height: 34,
		},
	},
	{
		name: 'cz',
		logo: {
			alt: 'Zorgverzekeraar cz',
			src: '/img/health-insurers/cz.png',
			width: 80,
			height: 70,
		},
	},
	{
		name: 'de-friesland',
		logo: {
			alt: 'Zorgverzekeraar de-friesland',
			src: '/img/health-insurers/de-friesland.png',
			width: 80,
			height: 10,
		},
	},
	{
		name: 'ditzo',
		logo: {
			alt: 'Zorgverzekeraar ditzo',
			src: '/img/health-insurers/ditzo.png',
			width: 80,
			height: 40,
		},
	},
	{
		name: 'dsw',
		logo: {
			alt: 'Zorgverzekeraar dsw',
			src: '/img/health-insurers/dsw.png',
			width: 80,
			height: 35,
		},
	},
	{
		name: 'fbto',
		logo: {
			alt: 'Zorgverzekeraar fbto',
			src: '/img/health-insurers/fbto.png',
			width: 80,
			height: 48,
		},
	},
	{
		name: 'hema',
		logo: {
			alt: 'Zorgverzekeraar hema',
			src: '/img/health-insurers/hema.png',
			width: 80,
			height: 75,
		},
	},
	{
		name: 'interpolis',
		logo: {
			alt: 'Zorgverzekeraar interpolis',
			src: '/img/health-insurers/interpolis.webp',
			width: 80,
			height: 60,
		},
	},
	{
		name: 'intwente',
		logo: {
			alt: 'Zorgverzekeraar intwente',
			src: '/img/health-insurers/intwente.webp',
			width: 80,
			height: 32,
		},
	},
	{
		name: 'iza',
		logo: {
			alt: 'Zorgverzekeraar iza',
			src: '/img/health-insurers/iza.png',
			width: 80,
			height: 40,
		},
	},
	{
		name: 'izz',
		logo: {
			alt: 'Zorgverzekeraar izz',
			src: '/img/health-insurers/izz.jpeg',
			width: 80,
			height: 81,
		},
	},
	{
		name: 'jaaah',
		logo: {
			alt: 'Zorgverzekeraar jaaah',
			src: '/img/health-insurers/jaaah.png',
			width: 80,
			height: 26,
		},
	},
	{
		name: 'just',
		logo: {
			alt: 'Zorgverzekeraar just',
			src: '/img/health-insurers/just.png',
			width: 80,
			height: 34,
		},
	},
	{
		name: 'menzis',
		logo: {
			alt: 'Zorgverzekeraar menzis',
			src: '/img/health-insurers/menzis.png',
			width: 80,
			height: 38,
		},
	},
	{
		name: 'nationale-nederlanden',
		logo: {
			alt: 'Zorgverzekeraar nationale-nederlanden',
			src: '/img/health-insurers/nationale-nederlanden.png',
			width: 80,
			height: 80,
		},
	},
	{
		name: 'ohra',
		logo: {
			alt: 'Zorgverzekeraar ohra',
			src: '/img/health-insurers/ohra.png',
			width: 80,
			height: 29,
		},
	},
	{
		name: 'onvz',
		logo: {
			alt: 'Zorgverzekeraar onvz',
			src: '/img/health-insurers/onvz.png',
			width: 80,
			height: 17,
		},
	},
	{
		name: 'prolife',
		logo: {
			alt: 'Zorgverzekeraar prolife',
			src: '/img/health-insurers/prolife.png',
			width: 80,
			height: 35,
		},
	},
	{
		name: 'salland',
		logo: {
			alt: 'Zorgverzekeraar salland',
			src: '/img/health-insurers/salland.png',
			width: 80,
			height: 48,
		},
	},
	{
		name: 'stadholland',
		logo: {
			alt: 'Zorgverzekeraar stadholland',
			src: '/img/health-insurers/stadholland.png',
			width: 80,
			height: 31,
		},
	},
	{
		name: 'studenten-goed-verzekerd',
		logo: {
			alt: 'Zorgverzekeraar studenten-goed-verzekerd',
			src: '/img/health-insurers/studenten-goed-verzekerd.png',
			width: 80,
			height: 37,
		},
	},
	{
		name: 'szvk',
		logo: {
			alt: 'Stichting Ziektekostenverzekering Krijgsmacht',
			src: '/img/health-insurers/szvk.png',
			width: 80,
			height: 52,
		},
	},
	{
		name: 'umc-zorgverzekering',
		logo: {
			alt: 'Zorgverzekeraar umc-zorgverzekering',
			src: '/img/health-insurers/umc-zorgverzekering.png',
			width: 80,
			height: 30,
		},
	},
	{
		name: 'united-consumers',
		logo: {
			alt: 'Zorgverzekeraar united-consumers',
			src: '/img/health-insurers/united-consumers.png',
			width: 80,
			height: 45,
		},
	},
	{
		name: 'unive',
		logo: {
			alt: 'Zorgverzekeraar unive',
			src: '/img/health-insurers/unive.png',
			width: 80,
			height: 25,
		},
	},
	{
		name: 'vgz',
		logo: {
			alt: 'Zorgverzekeraar vgz',
			src: '/img/health-insurers/vgz.png',
			width: 80,
			height: 65,
		},
	},
	{
		name: 'vgzbewuzt',
		logo: {
			alt: 'Zorgverzekeraar vgzbewuzt',
			src: '/img/health-insurers/vgzbewuzt.png',
			width: 80,
			height: 24,
		},
	},
	{
		name: 'vinkvink',
		logo: {
			alt: 'Zorgverzekeraar vinkvink',
			src: '/img/health-insurers/vinkvink.png',
			width: 80,
			height: 53,
		},
	},
	{
		name: 'vvaa',
		logo: {
			alt: 'Zorgverzekeraar vvaa',
			src: '/img/health-insurers/vvaa.png',
			width: 80,
			height: 17,
		},
	},
	{
		name: 'zekur',
		logo: {
			alt: 'Zorgverzekeraar zekur',
			src: '/img/health-insurers/zekur.png',
			width: 80,
			height: 40,
		},
	},
	{
		name: 'ziezo',
		logo: {
			alt: 'Zorgverzekeraar ziezo',
			src: '/img/health-insurers/ziezo.png',
			width: 80,
			height: 32,
		},
	},
	{
		name: 'zilveren-kruis',
		logo: {
			alt: 'Zorgverzekeraar zilveren-kruis',
			src: '/img/health-insurers/zilveren-kruis.png',
			width: 80,
			height: 35,
		},
	},
	{
		name: 'zorg-en-zekerheid',
		logo: {
			alt: 'Zorgverzekeraar zorg-en-zekerheid',
			src: '/img/health-insurers/zorg-en-zekerheid.png',
			width: 80,
			height: 41,
		},
	},
];

export default insurers;
